module.exports = __webpack_public_path__ + "img/isPro2_3.62f17c06.png";